import { Component } from '@angular/core';

@Component({
  selector: 'app-identibase-review',
  templateUrl: './identibase-review.component.html',
  styleUrl: './identibase-review.component.scss'
})
export class IdentibaseReviewComponent {

}
